import { Component, Input, OnInit, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-hotels-selection-input',
  templateUrl: './hotels-selection-input.component.html',
  styleUrls: ['./hotels-selection-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HotelsSelectionInputComponent),
      multi: true,
    },
  ],
})
export class HotelsSelectionInputComponent implements OnInit, ControlValueAccessor {

  @Input() groupedHotels: any;
  formattedHotels: any[] = [];

  selectedHotels: {
    destination: string;
    locations: {
      locationName: string;
      hotels: any[];
    }[];
  }[] = [];

  dropdownVisible: boolean = false;
  isDisabled: boolean = false;

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor() { }

  ngOnInit() {
    this.formattedHotels = JSON.parse(JSON.stringify(this.groupedHotels));
  }

  toggleDropdown(): void {
    if (this.isDisabled) return;
    this.dropdownVisible = !this.dropdownVisible;
  }

  isChecked(destination: string, locationName: string, hotel: any): boolean {
    const dest = this.selectedHotels.find(d => d.destination === destination);
    if (!dest) return false;

    const loc = dest.locations.find(l => l.locationName === locationName);
    if (!loc) return false;

    return loc.hotels.some(h => h.hotelName === hotel.hotelName);
  }

  selectHotel(destination: string, locationName: string, hotel: any): void {    
    if (this.isDisabled) return;

    // Find or create destination
    let dest = this.selectedHotels.find(d => d.destination === destination);

    if (!dest) {
      dest = {
        destination,
        locations: []
      };
      this.selectedHotels.push(dest);
    }

    // Find or create location
    let loc = dest.locations.find(l => l.locationName === locationName);

    if (!loc) {
      loc = {
        locationName,
        hotels: []
      };
      dest.locations.push(loc);
    }

    // Enforce single selection per location
    loc.hotels = [hotel];

    this.propagateChange();
  }

  removeHotel(destination: string, locationName: string): void {
    if (this.isDisabled) return;

    const destIndex = this.selectedHotels.findIndex(
      d => d.destination === destination
    );

    if (destIndex !== -1) {
      const dest = this.selectedHotels[destIndex];

      dest.locations = dest.locations.filter(
        l => l.locationName !== locationName
      );

      // Remove the entire destination if no locations left
      if (dest.locations.length === 0) {
        this.selectedHotels.splice(destIndex, 1);
      }

      this.propagateChange();
    }
  }

  propagateChange(): void {
    this.onChange(this.selectedHotels);
  }

  writeValue(value: any): void {
    this.selectedHotels = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
      this.dropdownVisible = false;
    }
  }

  testLog(){
    console.log("CLICKED");
    
  }
}
